import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/assets/lang/cn'
import axios from 'axios'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'cn',
  fallbackLocale: 'cn',
  messages // 设置语言环境信息
})

const loadedLanguages = ['cn'] // 我们的预装默认语言

function setI18nLanguage (lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync (lang) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return import(`@/assets/lang/${lang}`).then(msgs => {
        i18n.setLocaleMessage(lang, msgs.default[lang])
        loadedLanguages.push(lang)
        return setI18nLanguage(lang)
      })
    }
    return Promise.resolve(setI18nLanguage(lang))
  }
  return Promise.resolve(lang)
}
